import React, { useState } from 'react';
import './PuzzleGame.css';

const generatePuzzlePieces = (content) => {
  // Split content into smaller parts to create puzzle pieces
  // const size = Math.sqrt(content.length);
  // let pieces = [];
  // for (let i = 0; i < size; i++) {
  //   pieces.push(content.slice(i * size, (i + 1) * size));
  // }
  // return pieces;

  
  return content.split(''); // Break content into individual characters


};

const PuzzleGame = () => {
  const [puzzleContent, setPuzzleContent] = useState('');
  const [pieces, setPieces] = useState([]);
  const [shuffledPieces, setShuffledPieces] = useState([]);
  const [solved, setSolved] = useState(false);

  const createPuzzle = () => {
    const generatedPieces = generatePuzzlePieces(puzzleContent);
    setPieces(generatedPieces);
    setShuffledPieces(shuffleArray([...generatedPieces]));
  };

  const shuffleArray = (array) => {
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
  };

  const checkSolution = () => {
    setSolved(JSON.stringify(pieces) === JSON.stringify(shuffledPieces));
  };
  const openUrl = () => {
    window.open('https://draftj.in', '_blank');
}

  return (
    <div className="AppPuz">
      <h1>Jigsaw - Puzzle Game</h1>
      
      <h2>Enter word or number in the following text box and click create puzzle button</h2>
      <input 
        type="text" 
        value={puzzleContent} 
        onChange={(e) => setPuzzleContent(e.target.value)} 
        placeholder="Enter words or numbers" 
      />
      <button onClick={createPuzzle}>Create Puzzle</button>
      &nbsp;&nbsp;
            <button onClick={openUrl}>Home</button>
            
      <p>Click on create puzzle button until you find the right answer.</p>
      <div className="puzzle-board">
        {shuffledPieces.map((piece, index) => (
          <div key={index} className="puzzle-piece">{piece}</div>
        ))}
      </div>
      <button onClick={checkSolution}>Check Solution</button>
      {solved ? <h2>Congratulations! You solved the puzzle!</h2>: <h2>Try Again...</h2>}
      
      <p><h2>If the answer is right then click on check solution...</h2></p>
      <br/><br/><br/>
      <h2> &nbsp; &nbsp; &nbsp; &nbsp;&nbsp; This game helps the kids to build creativity and also helps to utilize imaginary, mindful intellectual and other senses at once.</h2>
    </div>
  );
};

export default PuzzleGame;